import React from 'react';
import styled from 'styled-components/macro';

import NoSearchResults from 'components/utility/NoResults/NoResults';
import BaseNoData from 'components/styled/NoData/NoData';
import { ThemeProps } from 'types/styled';
import { EntityTypes } from 'context/entityContext';

const NoData = styled(BaseNoData)<ThemeProps<'div'>>`
  margin: ${(p): string => p.theme.spacing.medium} auto;
`;

interface IProps {
  browseEntityType: EntityTypes;
  searchValue: string;
  isLargeScreen: boolean;
  selectedSalesType: {
    label: string;
    value: string;
  };
}

const NoResults: React.FC<IProps> = (props) => {
  const {
    browseEntityType,
    searchValue,
    isLargeScreen,
    selectedSalesType,
  } = props;

  if (searchValue.length > 0) {
    return <NoSearchResults searchValue={searchValue} />;
  }
  return (
    <NoData isSmallScreen={!isLargeScreen}>
      <p>
        Unfortunately there is no{' '}
        {selectedSalesType && selectedSalesType.label.toLowerCase()} data
        available for{' '}
        {browseEntityType === 'track'
          ? 'these filtered tracks'
          : `this ${browseEntityType}`}
        .
      </p>
    </NoData>
  );
};

export default NoResults;
